import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import Body from '../../components/body';
import Heading from '../../components/heading';
import Seo from '../../components/seo';
import { scaleBand, scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
import Bar3 from '../../components/Bar3';
import BarLegend from '../../components/Bar2';
import Code from '../../components/code';

const fruits = [
    { name: "🍊", count: 21, good: 12 },
    { name: "🍇", count: 13, good: 10 },
    { name: "🍏", count: 8, good: 5 },
    { name: "🍌", count: 5, good: 3 },
    { name: "🍐", count: 3, good: 1 },
    { name: "🍋", count: 2, good: 2 },
    { name: "🍎", count: 1, good: 1 },
    { name: "🍉", count: 1, good: 0 }
]

const HorizontalBar2 = () => {
    const margin = ({ top: 40, bottom: 20, left: 40, right: 20 })
    const [width, setWidth] = useState(400)
    const height = 500;
    const xScale = scaleLinear()
        .domain([0, max(fruits, d => d.count)])
        .range([0, width - 3 * margin.right - margin.left - 20])
    const yScale = scaleBand()
        .domain(fruits.map(d => d.name))
        .range([margin.top, height - margin.bottom])
        .padding(0.1)
    const updateDimensions = () => {
        setWidth(window.outerWidth);
    }
    useEffect(() => {
        setWidth(window.outerWidth);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    return (
        <Layout>
            <Seo title="HorizontalBar Charts-II" />
            <Heading heading="HorizontalBar Chart-II" />
            <Body>
                <p>In the last chapter we made horizontal Bar charts with axis.
                    Today we will start by building a Bar chart with more than three data points.
                    <br />
                    <br />
                    We have a data set which
                    has a type of fruit,total number of fruits and how many good ones out of the total.
                </p>
                <Code>
                        {`const fruits = [
    { name: "🍊", count: 21, good: 12 },
    { name: "🍇", count: 13, good: 10 },
    { name: "🍏", count: 8, good: 5 },
    { name: "🍌", count: 5, good: 3 },
    { name: "🍐", count: 3, good: 1 },
    { name: "🍋", count: 2, good: 2 },
    { name: "🍎", count: 1, good: 1 },
    { name: "🍉", count: 1, good: 0 }
]`}
                    </Code>
                <p>
                    So like the previous charts we can have one non continous scale and two linear scales.
                    The name can be the band scale, count and good can be projected in linear scale.
                    <br /><br />As per my assumption,
                    Since D3 and react gives a lot of freedom on svg manipulation so my idea will be to make two
                    rectangle and project one top of another. So first create the same horizontal Bar from previous
                    tutorial and then add good rectangle on top of count rectangle.
                </p>
                <div className="my-2 sm:my-4 border dark:bg-gray-500 bg-gray-200 rounded">
                    <Bar3
                        data={fruits}
                        width={width}
                        height={height}
                        xScale={xScale}
                        yScale={yScale}
                        margin={margin} />
                </div>
                <p>
                    I doubt this is the best way of representing three data points on a chart.
                    The Next thing is to add legend to tell about what the color means.
                </p>
                <div className="my-2 sm:my-4 border dark:bg-gray-500 bg-gray-200 rounded">
                    <BarLegend
                        data={fruits}
                        width={width}
                        height={height}
                        xScale={xScale}
                        yScale={yScale}
                        margin={margin} />
                </div>
                <p>
                    To add the legend I simply add a rectangle in the bottom right quadrant since I had
                    the space there. I don't think the bar chart does a justice to the data though.
                </p>
            </Body>
        </Layout >
    )
}



export default HorizontalBar2